import axios from "axios";
import StoreHandler from "./StoreHandler";
import Util from "./Util";

class Api_Mec {
  constructor() {
    var varUrl =
      //window.location.protocol+"//"+window.location.hostname; //+":"+window.location.port;
      "https://www.aprocom.com.co/MEC";
    // "http://localhost:3000";
    this.url_api = varUrl;
    //this.enc_tunnel = false; //Se utiliza para definir si los requerimientos POST van encriptados
    this.str_claenc =
      "tHisECusuFrostlJAvLzl!tipUkawRistiC$aT9w&ECrLrIT&DRozIgAhI&o1l!u"; //Esta clave es temporal, se debe utilizar una variable de entorno
    //y esta clave debe estar igual en el back en el middware EncTunnel
  }

  async post(url, paramsT, headers) {
    var util = new Util();
    var storeHandler = new StoreHandler();
    var token = storeHandler.getItem("mec_tk_a");

    var params = {};

    //console.log(typeof paramsT);

    if (headers.enct) {
      if (paramsT != null && typeof paramsT.get === "function") {
        paramsT.forEach(function (value, key) {
          params[key] = value;
        });

        params.date_request = new Date().getTime();

        params = {
          pksienc: util.encryp(JSON.stringify(params), this.str_claenc),
        };
      } else {
        if (paramsT != null) {
          paramsT.date_request = new Date().getTime();
        }

        params = {
          pksienc: util.encryp(JSON.stringify(paramsT), this.str_claenc),
        };
      }
    } else {
      params = paramsT;
    }

    if (token) {
      headers.Authorization = "Bearer " + token;
    }

    var resp = null;

    try {
      resp = await axios
        .post(url, params, { headers })
        .then((response) => {
          return response;
        })
        .catch((e) => {
          return e;
        });

      if (headers.enct && resp.data && resp.data.pkgr) {
        var dataEnc = resp.data.pkgr;
        var data = JSON.parse(util.decryp(dataEnc, this.str_claenc));
        resp.data = data;
        //console.log(data);
      }

      //console.log(resp);
    } catch (e) {
      console.log(e);
    }

    return resp;
  }

  get(url, headers) {
    var storeHandler = new StoreHandler();
    if (!headers) {
      headers = {};
    }
    if (storeHandler.getItem("mec_tk_a")) {
      headers = {
        authorization: "Bearer " + storeHandler.getItem("mec_tk_a"),
      };
    }

    //console.log(headers);

    return axios.get(url, {
      headers: headers,
      responseType: "arraybuffer",
    });
  }

  //? Obtneer el link de la Api para usarlo en el front como ruta
  async getUrlApi() {
    let resp = {
      data: { result: { url_api: this.url_api } },
    };

    return resp;
  }

  //------------------------------------------------------------------
}
export default Api_Mec;
